const partners = [
  {
    name: "XM",
    logo: require("../assets/partners/partner-1.png"),
    link: "https://clicks.pipaffiliates.com/c?c=1072070&l=en&p=1",
  },
  {
    name: "VT markets",
    logo: require("../assets/partners/partner-3.png"),
    link: "https://www.vtmarkets.com/trade-now/?affid=900654",
  },
  {
    name: "Space World Capital",
    logo: require("../assets/partners/partner-5.png"),
    link: "https://cabinet.spaceworldcapital.com/client/register/67c6d643f2a3a",
  },
  {
    name: "EoneFX",
    logo: require("../assets/partners/partner-7.png"),
    link: "#",
  },
  // {
  //   name: "Pepperstone",
  //   logo: require("../assets/partners/partner-2.png"),
  //   link: "https://partner.com",
  // },
  // {
  //   name: "Octa",
  //   logo: require("../assets/partners/partner-4.png"),
  //   link: "https://partner.com",
  // },
  // {
  //   name: "Exness",
  //   logo: require("../assets/partners/partner-6.png"),
  //   link: "https://partner.com",
  // },
];

export default partners;
